var _rect, _g, _rect2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideocamBrown = function SvgVideocamBrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18542_22423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18542_22423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36589 16.6576C2.90755 16.6576 2.51519 16.4944 2.1888 16.168C1.86241 15.8416 1.69922 15.4492 1.69922 14.9909V4.99089C1.69922 4.53255 1.86241 4.14019 2.1888 3.8138C2.51519 3.48741 2.90755 3.32422 3.36589 3.32422H13.3659C13.8242 3.32422 14.2166 3.48741 14.543 3.8138C14.8694 4.14019 15.0326 4.53255 15.0326 4.99089V8.74089L17.6576 6.11589C17.7964 5.977 17.9492 5.94227 18.1159 6.01172C18.2826 6.08116 18.3659 6.21311 18.3659 6.40755V13.5742C18.3659 13.7687 18.2826 13.9006 18.1159 13.9701C17.9492 14.0395 17.7964 14.0048 17.6576 13.8659L15.0326 11.2409V14.9909C15.0326 15.4492 14.8694 15.8416 14.543 16.168C14.2166 16.4944 13.8242 16.6576 13.3659 16.6576H3.36589Z",
    fill: "#652B19"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18542_22423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 11,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33008,
    y: 5,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18542_22423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71484 13.4674C7.65234 13.4466 7.60026 13.4102 7.55859 13.3581C7.51693 13.306 7.49609 13.2418 7.49609 13.1654V10.832H7.07943C6.85026 10.832 6.65408 10.7504 6.49089 10.5872C6.32769 10.424 6.24609 10.2279 6.24609 9.9987V6.66536C6.24609 6.4362 6.32769 6.24002 6.49089 6.07682C6.65408 5.91363 6.85026 5.83203 7.07943 5.83203H9.51693C9.73915 5.83203 9.91797 5.91884 10.0534 6.09245C10.1888 6.26606 10.2287 6.45703 10.1732 6.66536L9.57943 8.7487H10.0482C10.2982 8.7487 10.4839 8.85981 10.6055 9.08203C10.727 9.30425 10.7148 9.51953 10.569 9.72786L8.06901 13.3424C8.02734 13.4049 7.97352 13.4466 7.90755 13.4674C7.84158 13.4883 7.77734 13.4883 7.71484 13.4674Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideocamBrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Videocam-brown.d29a66ed.svg";
export { ForwardRef as ReactComponent };